// 象棋相关的术语配置

/**
 * 颜色
 */
export enum ColorEnum {
    WHITE = 'white',
    BLACK = 'black',
}

/**
 * 角色
 */
export enum ChessRoleEnum {
    K = 'K',
    Q = 'Q',
    P = 'P',
    R = 'R',
    B = 'B',
    N = 'N',
    k = 'k',
    q = 'q',
    p = 'p',
    r = 'r',
    b = 'b',
    n = 'n',
}

/**
 * 升变可选角色
 */
export enum PromotionEnum {
    QUEEN = 'q',
    ROOK = 'r',
    BISHOP = 'b',
    KNIGHT = 'n',
}

export enum GameOverWayEnum {
    DRAW = 'DRAW', // 50 内未杀子且兵没有移动
    CHECKMATE = 'CHECKMATE', // 将杀
    STALEMATE = 'STALEMATE', // 欠行 （和）
    THREEFOLD_REPETITION = 'THREEFOLD_REPETITION', // 三次重复 (和)
    INSUFFICIENT_MATERIAL = 'INSUFFICIENT_MATERIAL', // 没有足够棋力将杀
}

export enum GameOverResultEnum {
    WHITE = '1-0',
    BLACK = '0-1',
    DRAW  = '½-½',
}